import { isEmpty } from 'lodash';
import Raven from 'raven-js';
import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import * as api from '../../api';
import * as analytics from '../../api/analytics';
import { sellerFlowPagePath } from '../../routes/pathBuilders';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import * as selectors from './selectors';

function* maybeFetchProfileData(action) {
  const profileData = yield select(selectors.profileData);
  if (profileData.size === 0 || action.payload.forceFetch) {
    yield put(actions.beginLoadingProfileData());
    try {
      const data = yield call(
        api.fetchHomeProfile,
        action.payload.homeProfileSlug,
        action.payload.leadToken,
      );
      yield put(
        actions.receiveData(
          data['profile_data'],
          data['market_identifier'],
          data['brokerage_info'],
        ),
      );
    } catch (e) {
      yield put(actions.errorProfileData(e.message));
      Raven.captureException(e);
    }
  }
  const marketIdentifier = yield select(selectors.marketIdentifier);
  const address = yield select(selectors.address);
  yield put(actions.maybeFetchMarketTrends(marketIdentifier, address.postal_code));
}

function* maybeFetchMarketTrends(action) {
  const marketTrends = yield select(selectors.marketTrends);
  if (isEmpty(marketTrends)) {
    const { market, zipCode } = action.payload;
    try {
      const { marketPrices, zipCodePrices } = yield call(api.fetchMarketTrends, market, zipCode);
      if (!isEmpty(marketPrices) && !isEmpty(zipCodePrices)) {
        yield put(actions.receiveMarketTrends({ market: marketPrices, zipCode: zipCodePrices }));
      } else {
        Raven.captureException({
          message: `marketPrices isEmpty: ${isEmpty(
            marketPrices,
          )}, zipCodePrices isEmpty: ${isEmpty(zipCodePrices)}`,
          name: 'MarketTrends',
        });
      }
    } catch (e) {
      Raven.captureException(e);
    }
  }
}

function* toInputFlow(action) {
  const lead = yield call(api.moveToInputFlow, action.payload.addressToken, 'home_value_report', [
    'p_home_profile',
  ]);
  // because home profiles exist on Rails and not Reception, we do a full page navigation
  window.location.href = sellerFlowPagePath({ token: lead.token, slug: undefined });
}

function* trackEvent(actionParam) {
  const { category, action, label, extra } = actionParam.payload;
  analytics.trackEvent(category, action, label, extra);
}

function* trackLead(action) {
  yield call(api.trackLead, action.payload.keywords);
}

export default function* saga() {
  yield all([
    takeLatest(actionTypes.MAYBE_FETCH_PROFILE_DATA, maybeFetchProfileData),
    takeLatest(actionTypes.MAYBE_FETCH_MARKET_TRENDS, maybeFetchMarketTrends),
    takeLatest(actionTypes.TO_INPUT_FLOW, toInputFlow),
    takeEvery(actionTypes.TRACK_EVENT, trackEvent),
    takeEvery(actionTypes.TRACK_LEAD, trackLead),
  ]);
}
